import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { ApiService } from '../service/api.service';

@Injectable({
  providedIn: 'root'
})
export class AdminResolverService implements Resolve<any> {


  constructor(private api:ApiService,private router:Router) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any{
    // let role=localStorage.getItem("user_role");
    // const formValue={flag:role};
    return forkJoin([this.api.get('menuList')]);
    
  }

  erro401Unauth()
  {
    localStorage.clear();
    this.router.navigate(['/login']);

  }
}
